<template>
    <div class="MatchRules">
        <DataGrid
            ref="dataGrid"
            class="DataGrid"
            v-bind="dataGridConfig"
            :columns="data.columns || []"
            :rows="data.rows || []"
            :selectGroups="selectGroups"
            :loading="isFetching"
            @onRowDoubleClicked="handleDoubleClickRow"
        />

        <Modal
            :opened="[modals.CREATE, modals.UPDATE].includes(modal)"
            :title="$route.meta.breadcrumb"
            class="ModalForm"
            #body
            @close="handleCleanModal"
        >
            <MatchForm
                :node="(node || {}).data"
                :selectGroups="selectGroups"
                :action="modal"
                :entityKey="entityKey"
                @onReset="handleCleanModal"
                @onSubmit="handleSubmit"
                @onError="handleCleanModal"
            />
        </Modal>

        <ModalRequest
            :opened="modal === modals.REMOVE"
            :title="$t('entities.modals.remove.text')"
            :cancelText="$t('actions.cancel')"
            :okText="$t('actions.confirm')"
            :loading="isLoading"
            @close="handleCleanModal"
            @onAccept="removeEntity"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import {
    Api, apiRequest, rethrowError, notifyError,
} from '@/api'
import { DataGrid, ModalRequest, Modal } from '@/components'
import { MatchForm } from './components'
import Grid from './grid'

const MODALS = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    REMOVE: 'REMOVE',
}

export default {
    name: 'MatchRules',
    components: {
        DataGrid,
        ModalRequest,
        Modal,
        MatchForm,
    },
    props: {
        entityKey: VueTypes.string,
        matchRules: VueTypes.any,
        selectGroups: VueTypes.any,
        isFetching: VueTypes.bool.def(false),
    },
    data () {
        return {
            node: undefined,
            isLoading: false,

            modal: undefined,
            modals: MODALS,

            dataGridConfig: {
                ...Grid.config,
                contextMenu: this.contextMenu,
            },
        }
    },
    computed: {
        data () {
            return {
                columns: Grid.columns,
                rows: this.matchRules || [],
            }
        },
    },
    methods: {
        contextMenu ({ node, api }) {
            const renderIcon = icon => `<i class="WIcon icon-${icon} ag-icon" />`
            const { data = {} } = node

            return [
                'copy',
                'paste',
                'separator',
                ...([
                    {
                        name: this.$t('entities.actions.edit'),
                        action: () => this.handleRequest(MODALS.UPDATE, node),
                        icon: renderIcon('edit'),
                    },
                    {
                        name: this.$t('entities.actions.delete'),
                        action: () => this.handleRequest(MODALS.REMOVE, node),
                        icon: renderIcon('trash'),
                        disabled: data.locked,
                    },
                ]),
                'separator',
                {
                    name: this.$t('entities.actions.export'),
                    action: () => api.exportDataAsCsv({ columnSeparator: '\t' }),
                    icon: renderIcon('download'),
                },
            ]
        },
        handleRequest (modal, node) {
            this.node = node
            if (modal) this.modal = modal
        },
        handleCleanModal () {
            this.modal = undefined
        },
        handleDoubleClickRow (node) {
            this.handleRequest(this.modals.UPDATE, node)
        },
        onNewRow () {
            this.handleRequest(this.modals.CREATE)
        },
        handleSubmit () {
            this.$emit('onFetchData')
            this.handleCleanModal()
        },
        async removeEntity () {
            this.isLoading = true
            const { data } = this.node
            apiRequest(Api().entities.matchRuleDelete({ entityKey: this.entityKey, ruleKey: data.key }))
                .then(() => this.$refs.dataGrid.removeRow(this.node))
                .catch(rethrowError(notifyError()))
                .finally(() => {
                    this.handleCleanModal()
                    this.isLoading = false
                })
        },
    },
}
</script>
<style lang="scss" scoped>
.MatchRules {
	position: relative;
}

.ModalForm {
    &::v-deep .Dialog {
        max-width: 800px;
    }
}
</style>
